import { memoize } from '@/lib/helpers';
import { PRODUCTS_PATH } from '@/constants/endpoints';
import { getJson } from '../request';

export const getProducts = memoize(() => {
  return getJson(PRODUCTS_PATH);
});
